import { Result } from "../../models/result";

export const getTotalPages = (resultCount: number, resultsPerPage: number) => {
	if (resultCount === 0) {
		return 0;
	}

	return Math.floor(
		resultCount === 0 ? 0 : (resultCount - 1) / resultsPerPage + 1,
	);
};
